import React from 'react';
import { usePermissions } from 'context/PermissionProvider';

interface CanProps {
  permission?: string;
  anyOf?: string[];
  allOf?: string[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Renders children only when the current user has the required permission(s).
 */
const Can: React.FC<CanProps> = ({ permission, anyOf, allOf, fallback = null, children }) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, isLoading } = usePermissions();

  if (isLoading) return null;

  let allowed = true;

  if (permission) {
    allowed = hasPermission(permission);
  } else if (anyOf?.length) {
    allowed = hasAnyPermission(anyOf);
  } else if (allOf?.length) {
    allowed = hasAllPermissions(allOf);
  }

  return allowed ? <>{children}</> : <>{fallback}</>;
};

export default Can;
